import { StyledTopSection } from './Styled';
import { Container } from '../../styles/chime-react/CommonStyles';
import Heading from '../chat/Heading';

const Unvailable = () => {
  return (
    <>
      <StyledTopSection>
        <Container maxWidth="67.5rem">
          <Heading level={1} className="service-name" alignCenter>
            LINE問合せ・メッセージ問合せ
            <br />
            （反響）
          </Heading>
          <div className="content-wrapper">
            <div className="content-text">
              ご利用のIDは、現在このサービスをご利用いただけません。
              <br />
              お手数ですが、当社営業担当者か、カスタマーサポートにお問い合わせください。
            </div>
          </div>
        </Container>
      </StyledTopSection>
    </>
  );
};

export default Unvailable;
